$.npce.helpers = {
    update_select_options: function(select_element, data, prompt, prompt_empty, prompt_anyway) {
        select_element.empty(); // remove old options
        console.log(data);
        if(Object.keys(data).length == 0) {
            select_element.append($("<option></option>")
                .attr("value", '').html(prompt_empty));
        }
        if(Object.keys(data).length > 1 || prompt_anyway) {
            select_element.append($("<option></option>")
                .attr("value", '').html(prompt));
        }
        $.each(data, function(value,name) {
            select_element.append($("<option></option>")
                .attr("value", value).html(name));
        });
        if(Object.keys(data).length > 0 ) {
            select_element.val(Object.keys(data)[0]);
        }
    },

    spinner: function(show, id) {
        if (typeof id === "undefined") {
            id = '#spinner';
        }
        if(!$(id) && $('h1')) {
            var spinner = '<div id="spinner" style="display:none;"><i class="fa fa-fw fa-spinner fa-spin" aria-hidden="true"></i></div>';
            $('h1').prepend(spinner);
        }
        $(id).toggle(show);
    },

    checkErrors: function(error) {
        if(error && error.message) {
            var msg = "{{ __('Voi ei, tulipa ikävä yllätys. Jos ongelma toistuu, ota yhteys ylläpitäjään.') }}"
                + "<br><code>Error: " + error.message + "</code>";
            if(error.message.match('Unauth.*')) {
                msg = msg + "<br>{{ __('Uudelleenkirjautuminen voisi auttaa tähän ongelmaan.') }}";
            } else {
                msg = msg + "<br>{{ __('Luokittelematon virheilmoitus: Koodari oli kiireinen, eikä ohjelmoinut minua neuvomaan sinua tämän ongelman sattuessa.') }}";
            }
            var errormsgelement = $("<div class='alert alert-danger'></div>").html(msg);
            $('#errors_and_messages>div.col-xl-12').append(errormsgelement);
        }
    }
};

$('.toggle_all_there').click(function(e) {
    var $checkboxes = $(e.target).closest('.checkboxlist').find('input[type=checkbox]');
    $checkboxes.prop('checked', function( i, val ) { return !val; });
});

$(function () {
    $('[data-toggle="tooltip"]').tooltip();
});

jQuery.fn.extend({
    disable: function (state) {
        return this.each(function () {
            var $this = $(this);
            if(state) {
                $this.addClass('disabled');
                $this.prop('disabled', 'disabled');
            } else {
                $this.removeClass('disabled');
                $this.prop("disabled", false);
                $this.removeAttr('disabled');
            }
        });
    }
});
